/**
 *  @shelf-version: 1.1.0
 */

import ProductAttribute from './product-attribute';

export default ProductAttribute;
